import { render } from "./BaseTabItemSecondary.vue?vue&type=template&id=e142f024&scoped=true"
import script from "./BaseTabItemSecondary.vue?vue&type=script&lang=js"
export * from "./BaseTabItemSecondary.vue?vue&type=script&lang=js"

import "./BaseTabItemSecondary.vue?vue&type=style&index=0&id=e142f024&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e142f024"

export default script